import { useLoaderData, useNavigate, useSearchParams } from 'react-router';

import ReportAProblemModal from '~/components/modals/report-a-problem-modal';

export const loader = async () => {
  return {
    email: process.env.REPORT_A_PROBLEM_ADDRESS,
  };
};

// not currently used, but maybe some day...
// export const action = async ({ request, params }: ActionFunctionArgs) => {
//   await requireSession(request);
//   const formData = await request.formData();

//   await validateCSRF(formData, request.headers);

//   const { gymId, urlSlug } = await getGymIdAndSlugFromParams(params);
//   const returnRoute = TODO...

//   // TODO...

//   return redirectWithToast(returnRoute, {
//     title: 'Success!',
//     description: 'Report submitted successfully.',
//   });
// };

export default function ReportAProblem() {
  const { email } = useLoaderData<typeof loader>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const returnRoute = searchParams.get('returnRoute');

  const handleClose = () => {
    navigate(returnRoute ?? '..', { preventScrollReset: true });
  };

  return <ReportAProblemModal onClose={handleClose} email={email} />;
}
